import React, { useState, useEffect } from "react";
import { VoroLogo } from "./VoroLogo";
import { Menu, X, Download } from "lucide-react";

const links = [
    { label: "Features", href: "#features" },
    { label: "Community", href: "#community" },
    { label: "Events", href: "#events" },
    { label: "Partners+", href: "#partners" },
    { label: "Download App", href: "#download" },
];

export const Navbar = ({ onJoinClick }) => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        window.addEventListener("scroll", onScroll);
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="nav-bar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-2xl bg-black/60 border-b border-white/[0.06]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
                <a href="#top" data-testid="nav-logo" className="flex items-center">
                    <VoroLogo className="h-9" />
                </a>

                <nav className="hidden lg:flex items-center gap-9">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/[\s+]+/g, "-")}`}
                            className="text-[13.5px] text-white/70 hover:text-white transition-colors font-medium"
                        >
                            {l.label === "Download App" ? (
                                <span className="inline-flex items-center gap-1.5">
                                    <Download size={13} /> {l.label}
                                </span>
                            ) : (
                                l.label
                            )}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:block">
                    <button
                        data-testid="nav-cta-button"
                        onClick={onJoinClick}
                        className="px-5 py-2.5 rounded-full text-white text-[13.5px] font-semibold transition-all hover:scale-[1.03] shadow-[0_0_30px_rgba(139,92,246,0.35)]"
                        style={{
                            background:
                                "linear-gradient(135deg, #a855f7 0%, #8b5cf6 50%, #7c3aed 100%)",
                        }}
                    >
                        Join Waitlist
                    </button>
                </div>

                <button
                    data-testid="nav-mobile-toggle"
                    className="lg:hidden text-white p-2"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-white/5 bg-black/95 backdrop-blur-2xl">
                    <div className="px-5 py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-white/80 text-base"
                                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[\s+]+/g, "-")}`}
                            >
                                {l.label}
                            </a>
                        ))}
                        <button
                            onClick={() => {
                                setOpen(false);
                                onJoinClick && onJoinClick();
                            }}
                            data-testid="nav-mobile-cta-button"
                            className="mt-2 w-full px-5 py-3 rounded-full text-white font-semibold"
                            style={{
                                background:
                                    "linear-gradient(135deg, #a855f7 0%, #8b5cf6 50%, #7c3aed 100%)",
                            }}
                        >
                            Join Waitlist
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
